import React, { Component } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import AppRoutes from "./AppRoutes";
import { Layout } from "./components/Layout";
import { VzyLayout } from "./components/VzyLayout";
import { VzyHelpSupportLayOut } from "./components/VZY_Help_Support/VzyHelpSupportLayOut";
import "./custom.css";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
class AppWrapper extends Component {
  render() {
    return <AppWithRouter />;
  }
}

function getLayoutByPath(pathname) {
  const path = pathname.toLowerCase();
  if (path.includes("/vzysupport")) {
    return VzyHelpSupportLayOut;
  } else if (path.includes("/vzy")) {
    return VzyLayout;
  } else {
    return Layout;
  }
}

function AppWithRouter() {
  const location = useLocation();
  const SelectedLayout = getLayoutByPath(location.pathname);

  return (
    <SelectedLayout>
      <Routes>
        {AppRoutes.map((route, index) => {
          const { element, ...rest } = route;
          return <Route key={index} {...rest} element={element} />;
        })}
      </Routes>
    </SelectedLayout>
  );
}

export default AppWrapper;

// import React, { Component } from 'react';
// import { Route, Routes } from 'react-router-dom';
// import AppRoutes from './AppRoutes';
// import { Layout } from './components/Layout';
// import './custom.css';

// export default class App extends Component {
//     static displayName = App.name;

//   render() {
//       return (
//       <Layout>
//         <Routes>
//           {AppRoutes.map((route, index) => {
//             const { element, ...rest } = route;
//             return <Route key={index} {...rest} element={element} />;
//           })}
//         </Routes>
//         </Layout>
//     );
//   }
// }
